(function () {
	"use strict";

	function StackView() {
		this.View_constructor();

		this.build();
	}

	var p = createjs.extend(StackView, cm.View);

	p.build = function () {
		this.width = cm.app.display.width * 0.5;
		this.height = cm.app.display.height * 0.5;
		cm.main.currentManifest = "Stack";
		this.rulerContainer = new cjs.Container();
		this.endGameObjectStack = new cjs.Container().set({ name: 'end-game-object-stack-container' });
		this.endBoxContainer = new cjs.Container().set({ name: 'end-box-container' });
		this.endGameUI = new cjs.Container().set({ name: 'end-game-container' });
		this.hookContainer = new cjs.Container().set({ name: 'hook-container' });
		this.backgroundContainer = new cjs.Container().set({ name: 'background-container' });
		this.stackContainer = new cjs.Container().set({ name: 'stack-container' });
		this.uiContainer = new cjs.Container().set({ name: 'ui-container' });
		this.startedStacking = false;
		this.keysUsed = false;
		this.gameEnded = false;
		this.moveUp = false;
		this.isShowing = false;
		this.isHiding = false;
		this.canDestroy = true;
		this.isWaitingForItem = false;
		this.checkMeasurement = false;
		this.canCheckMeasurement = false;
		this.stackObjectMeasureContact = false;
		this.endGame = false;
		this.heightNum = 0;
		this.measurementNum = 0;
		this.measureTimer = 0;
		this.yParameter = 859;
		this.startingScore = this.getHighScore();
		this.moveUpAmount = 0;


		this.stackingObjects = [];
		this.selectedObject = null;
		this.selectedSprite = null;
		this.canUpdate = true;
		this.yPos = -1000;
		this.xPos = -200;
		this.stackY = 100;
		this.hookPool = [];
		this.hangingPool = [];


		this.bgArray = [];
		this.backGroundSetup();
		this.baseImage = new cjs.Bitmap(cm.Assets.lib.stackBase).set({y:248}).center();
		this.rulerContainer.addChild(this.baseImage);
		this.keyNav = new cm.KeyBoardNav();
		this.keyNav.navArrow = this.navArrow = new cjs.Sprite(cm.Assets.lib.gameSS, "sort-home-btn").set({visible:false}).center();
		this.addChild(this.backgroundContainer, this.hookContainer, this.rulerContainer, this.stackContainer, this.endBoxContainer, this.uiContainer);
		this.buildUI();
		this.buildWorld();
		this.createEndStack();
		cjs.Tween.get(this).wait(2000).call(this.showSelection, null, this);
	};

	p.checkStartingScore = function()
	{
		if(this.startingScore < 1){
			app.voPlayer.play("vo-26b", this.tutorialHand.bind(this));
		}
	};

	p.tutorialHand = function()
	{
		if(this.startedStacking){return;}
		this.tutHand = new cjs.Sprite(cm.Assets.lib.gameSS, "tut-hand").set({alpha:0, x:-300, y:200, scaleX:1.2, scaleY:1.2}).center();
		this.addChild(this.tutHand);
		cjs.Tween.get(this.tutHand, {loop:1})
		.wait(1000)
		.to({alpha:1}, 200)
		.to({x:this.hangingPool[0].x-50, y:this.hangingPool[0].y+100}, 1000, cjs.Ease.quadIn)
		.to({scaleX:1, scaleY:1}, 500)
		.to({x:0, y:0}, 1000, cjs.Ease.quadIn)
		.to({scaleX:1.1, scaleY:1.1}, 500)
		.to({alpha:0}, 200);

		if(cm.Device.mobile && cjs.Touch.isSupported())
			app.voPlayer.play("vo-183");
		else
			app.voPlayer.play("vo-192");
	};

	p.createEndStack = function()
	{
		var pos = [
			{ x: -155, y: 278, rotation: 0 },
			{ x: -190, y: 158, rotation: -85 },
			{ x: 16, y: 283, rotation: 0 },
			{ x: 101, y: 308, rotation: 0 },
			{ x: -49, y: 174, rotation: -80 },
			{ x: -64, y: 18, rotation: 0 },
			{ x: 220, y: 312, rotation: 90 },
			{ x: 129, y: 237, rotation: 100 },
			{ x: -115, y: 100, rotation: 110 },
			{ x: 70, y: 106, rotation: 295 },
			{ x: 237, y: 221, rotation: 138 }];

		var junk = [
			"stack-box",
			"stack-cereal",
			"stack-jar",
			"stack-milk-1",
			"stack-milk-2",
			"stack-ball",
			"stack-brick",
			"stack-clock",
			"stack-shoes",
			"stack-stool",
			"stack-bottle",
			"stack-coffee-can",
			"stack-cup",
			"stack-doll",
			"stack-glass-bottle",
			"stack-oj-bottle",
			"stack-party-hat",
			"stack-phone",
			"stack-shampoo-bottle",
			"stack-take-out",
			"stack-tire",
			"stack-magazine",
			"stack-crayon",
			"stack-soda"
		];
		for (var i = 0, l =11; i < l; i++) {
		   var object = new cjs.Sprite(cm.Assets.lib.junkSS, junk[i]).set({x:pos[i].x, y: pos[i].y, rotation: pos[i].rotation, name:junk[i]}).center();
		   this.endGameObjectStack.addChild(object);
		}
		this.endGameObjectStack.y = 1000;
		var endBox = new cjs.Sprite(cm.Assets.lib.miscSS, "gift-box").set({x:22, y:29, name:"gift-box"}).center();
		this.endBoxContainer.addChild(endBox);
		this.endBoxContainer.y = -1000;
		this.endBoxContainer.rotation = 20;
		this.rulerContainer.addChild(this.endGameObjectStack);

	};

	p.setupScore = function()
	{
		var scoreText = this.addText("Score:", 45, "#e06012");
		scoreText.set({x:-35, y:-32});
		var measureText = this.addText(this.measurementNum+" inches", 50, "#fe7135");
		measureText.set({x:-38, y:23}).center();

		var highscoreText = this.addText("High score:", 30, "#6a2baa");
		highscoreText.set({x:-20, y: 95});

		var hNum = this.getHighScore();
		var highMeasureText = this.addText(hNum+" inches", 30, "#9254d5");
		highMeasureText.set({x:-20, y:133});

		this.endBoxContainer.addChild(scoreText, measureText, highscoreText, highMeasureText);

	};

	p.getHighScore = function()
	{
		var scoreStorage = localStorage.getItem('stackHighScore');

		if (scoreStorage === null) {
			scoreStorage = this.measurementNum;
		}
		var localNum = JSON.parse(scoreStorage);
		if(this.measurementNum > localNum)
			scoreStorage = this.measurementNum;

		localStorage.setItem('stackHighScore', scoreStorage);
		return scoreStorage;
	};

	p.endGameHangItems = function()
	{
		var hook;
		for (var i = 0, l = this.hookPool.length; i < l; i++) {
		    hook = this.hookPool[i];
			var obj = this.hangingPool[i];
			cjs.Tween.get(hook, {override: true}).to({y:hook.y-700, alpha:0}, 3000, cjs.Ease.quadIn);
			if(obj){
				cjs.Tween.get(obj, {override: true}).to({y:obj.y-700, alpha: 0}, 3000, cjs.Ease.quadIn);
			}
		}
	};

	p.callEndGame = function()
	{
		this.endGameHangItems();
		this.gameEnded = true;
		if(this.selectedSprite)
			this.createStackObject();
		this.measureLine.visible = false;
		this.measureLine.sensor.kill();
		cjs.Tween.get(this.endGameObjectStack, {override:true})
		.to({y:0}, 500)
		.wait(4000)
		.call(this.destroyHangingItems, null, this)
		.wait(2000)
		.call(this.engine.removeAllEntities, null, this.engine);

		cjs.Tween.get(this)
		.wait(6000)
		.set({canUpdate: false});

		var hook;
		for (var i = 0, l = this.hookPool.length; i < l; i++) {
		    hook = this.hookPool[i];
			hook.y -=5;
			var obj = this.hangingPool[i];
			if(obj && obj !== this.selectedSprite )
				obj.y -=5;
			if(hook.y < -700 && this.isHiding){
				this.isHiding = false;
			}
		}

		cjs.Tween.get(this.rulerContainer, {override:true}).wait(2000).to({y:0}, 1000, cjs.Ease.quadInOut).wait(1000).call(this.dropBox, null, this);
	};

	p.dropBox = function()
	{
		this.isHiding = true;
		app.sound.play("present-drop");
		this.setupScore();
		cjs.Tween.get(this.endBoxContainer).to({y:0, rotation:10}, 500).to({rotation:0},100).call(this.callEndGameUI, null, this);
		this.replayButtonContainer.mouseEnabled = true;
		this.homeButtonContainer.mouseEnabled = true;
		this.removeHangingItemKeyNav();

	};

	p.callEndGameUI = function()
	{
		app.voPlayer.play("vo-27");
		cjs.Tween.get(this.replayButtonContainer).to({y:210}, 500, cjs.Ease.backOut);
		cjs.Tween.get(this.homeButtonContainer).to({y:210}, 500, cjs.Ease.backOut);
	};

	p.backGroundSetup = function()
	{
		var yPos = 0;
		for (var i = 0, l = 6; i < l; i++) {
			var background = new cjs.Bitmap(cm.Assets.lib.stackBackground).center();
			background.y = yPos;
			yPos -= 859;
			this.backgroundContainer.addChild(background);
			this.bgArray.push(background);
		}
	};

	p.buildWorld = function () {
		this.engine = new cm.Box2D();
		this.engine.createWorld(0, 9.8);
		this.engine.addContactListeners();

		if (cm.debug) {
			// this.engine.drawDebug(cm.main.debugLayer, cm.main.gameStage);
		}
		this.buildPhysicsScene();
		this.names = [
			{name:"stack-cereal", size: "small"},
			{name:"stack-jar", size: "medium"},
			{name:"stack-milk-1", size: "small"},
			{name:"stack-milk-2", size: "medium"},
			{name:"stack-ball", size: "medium"},
			{name:"stack-brick", size: "medium"},
			{name:"stack-clock", size: "medium"},
			{name:"stack-shoes", size: "medium"},
			{name:"stack-bottle", size: "small"},
			{name:"stack-coffee-can", size: "medium"},
			{name:"stack-cup", size: "small"},
			{name:"stack-doll", size: "small"},
			{name:"stack-glass-bottle", size: "medium"},
			{name:"stack-oj-bottle", size: "medium"},
			{name:"stack-party-hat", size: "small"},
			{name:"stack-phone", size: "small"},
			{name:"stack-shampoo-bottle", size: "medium"},
			{name:"stack-take-out", size: "small"},
			{name:"stack-tire", size: "large"},
			{name:"stack-magazine", size: "small"},
			{name:"stack-crayon", size: "small"},
			{name: "stack-soda", size: "small"}
		];
		this.names.shuffle();
		this.names.splice(0, 0, {name: "stack-stool", size: "large"});
		this.names.splice(3, 0, {name: "stack-box", size: "large"});
		var i, l;
		for (i = 0, l = 3; i < l; i++) {
			var n = this.names[i];
			this.buildHooks();
			this.hookObject(n, i);
			this.xPos += 250;
			var move = this.names.splice(i,1);
			this.names.push(move[0]);
		}
		this.xPos = -200;
		this.addRuler();
	};

	p.buildUI = function()
	{

		this.sharedUI = new cm.SharedUI("StackView");
		this.sharedUI.y = -100;
		this.replayButtonContainer = new cjs.Container().set({ mouseChildren: false });
		this.homeButtonContainer = new cjs.Container().set({ mouseChildren: false });


		var replayBg = new cjs.Sprite(cm.Assets.lib.gameSS, "big-button-bg").set({name: "replay-btn"}).center();
		var replayButton = new cjs.Sprite(cm.Assets.lib.gameSS, "replay-btn").center();
		this.replayButtonContainer.on("mousedown", this.buttonHandler, this);
		this.replayButtonContainer.on("mouseover", this.handleMouseOver, this);
		this.replayButtonContainer.on("mouseout", this.handleMouseOver, this);
		this.replayButtonContainer.on("click", this.buttonHandler, this);
		this.replayButtonContainer.addChild(replayBg, replayButton);
		this.replayButtonContainer.x = -262;
		this.replayButtonContainer.y = 800;
		this.replayButtonContainer.mouseEnabled = false;
		this.replayButtonContainer.placeArrow = "up";
		this.replayButtonContainer.name = "replay-btn";
		var homeBg = new cjs.Sprite(cm.Assets.lib.gameSS, "big-button-bg").set({name: "home-btn"}).center();
		var homeButton = new cjs.Sprite(cm.Assets.lib.gameSS, "stack-end-home").center();
		this.homeButtonContainer.addChild(homeBg, homeButton);
		this.homeButtonContainer.x = 227;
		this.homeButtonContainer.y = 800;
		this.homeButtonContainer.mouseEnabled = false;
		this.homeButtonContainer.placeArrow = "up";
		this.homeButtonContainer.name = "home-btn";
		this.homeButtonContainer.on("mousedown", this.buttonHandler, this);
		this.homeButtonContainer.on("mouseover", this.handleMouseOver, this);
		this.homeButtonContainer.on("mouseout", this.handleMouseOver, this);
		this.homeButtonContainer.on("click", this.buttonHandler, this);


		this.uiContainer.addChild(this.replayButtonContainer, this.homeButtonContainer);
		this.addChild(this.sharedUI, this.navArrow);
		this.sharedUI.addButtonToKeyNav();

	};

	p.handleMouseOver = function(e)
	{
		switch(e.target.name)
		{
			case "sort-replay-bg":
				app.voPlayer.play("vo-165");
			break;
			case "sort-home-bg":
			app.voPlayer.play("vo-124");

			break;
		}
		var scaleObj = e.target.getChildAt(1);
		if (e.type === "mouseover") {
			cjs.Tween.get(scaleObj).to({ scaleX: 1.1, scaleY: 1.1 }, 150);
		}

		if (e.type === "mouseout") {
			cjs.Tween.get(scaleObj).to({ scaleX: 1, scaleY: 1 }, 150);
		}
	};

	p.keyNavHandle = function(button)
	{
		switch(button.name){
			case "help-bg":
			case "pause-bg":
				this.sharedUI.handleClick(button.name);
			break;
			case "stack-box":
			case "stack-cereal":
			case "stack-jar":
			case "stack-milk-1":
			case "stack-milk-2":
			case "stack-ball":
			case "stack-brick":
			case "stack-clock":
			case "stack-shoes":
			case "stack-stool":
			case "stack-bottle":
			case "stack-coffee-can":
			case "stack-cup":
			case "stack-doll":
			case "stack-glass-bottle":
			case "stack-oj-bottle":
			case "stack-party-hat":
			case "stack-phone":
			case "stack-shampoo-bottle":
			case "stack-take-out":
			case "stack-tire":
			case "stack-magazine":
			case "stack-crayon":
			case "stack-soda":
				this.setKeySprite(button);
			break;
			case "replay-bg":
				this.replayLevel();
			break;
			case "home-btn":
				this.goToView();
			break;
		}
	};

	p.removeHangingItemKeyNav = function () {
		this.keyNav.buttons = [];
		this.sharedUI.addButtonToKeyNav();
		this.keyNav.buttons.push(this.replayButtonContainer, this.homeButtonContainer);
	};

	p.setKeySprite = function(button)
	{
		if(this.selectedSprite){return;}
		this.selectedSprite = button;
		this.removeHangingItemKeyNav();
		var num = this.hangingPool.indexOf(button);
		this.hangingPool.splice(num, 1);
		this.hideItems();

		this.isHiding = true;
		app.sound.play("servo-2");
	};

	p.addRuler = function()
	{
		var yPos = 190;
		var length = 10;
		for (var i = 0, l = 68; i < l; i++) {
			var ruler = new cjs.Sprite(cm.Assets.lib.gameSS, "ruler").set({ x: -this.width + 50, y: yPos });
			yPos -= 150;
			if (i % 2 === 0)
			{
				var textbg = this.addText(length, 27, "#000000");
				textbg.set({x: ruler.x + 85, y: yPos, outline:3});
				var text = this.addText(length, 27, "#f9d735");
				text.set({x: ruler.x + 85, y:yPos });
				this.rulerContainer.addChild(textbg, text);
				length +=10;
			}
				this.rulerContainer.addChild(ruler);
		}
		this.measureLine = new cm.MeasureLine(this.engine);
		this.measureLine.y = 400;
		this.rulerContainer.addChild(this.measureLine);
	};

	p.showSelection = function()
	{
		this.isShowing = true;
		this.bringInItems();
		this.isWaitingForItem = false;
	};

	p.playClawDownSound = function()
	{
		app.sound.play("servo-1");
	};

	p.setMeasureLine = function()
	{
		this.measureLine.stopSensing();
		var pt = this.rulerContainer.globalToLocal(this.measureLine.posCollection.x * b2.b2Scale + this.width, this.measureLine.posCollection.y * b2.b2Scale + this.height);
		cjs.Tween.get(this.measureLine).to({y:pt.y-18}, 1000, cjs.Ease.quadOut);
		this.measurementNum = Math.round((346 - pt.y+16) / 29);
	};

	p.addText = function(string, font, color)
	{
		var text = new cjs.Text(string, font+"px riffic-bold", color).center();
		return text;
	};

	p.hookObject = function(name, num)
	{
		var obj = new cjs.Sprite(cm.Assets.lib.junkSS, name.name).set({x:this.xPos, y: this.hookPool[num].y, name: name.name, size: name.size, placeArrow: "up"}).center();
		obj.y += obj.regY;

		this.hangingPool.push(obj);
		this.stackContainer.addChild(obj);

	};

	p.grabSound = function()
	{
		this.startedStacking = true;
		app.sound.play("grab");
		app.sound.play("servo-2");
	};

	p.setTutHandInvisible = function()
	{
		if(this.tutHand){
			cjs.Tween.get(this.tutHand, {override: true})
			.to({alpha:0}, 100)
			.set({visible: false});
		}
	};

	p.handleHookObject = function(e)
	{
		this.setTutHandInvisible();
		this.spliceHangingObject(e);
		e.target.x = e.stageX - this.width;
		e.target.y = e.stageY - this.height;
		if(!this.selectedSprite){
			this.hideItems();
		}
		this.selectedSprite = e.target;
		this.isHiding = true;
		if(this.navArrow.visible)
			this.navArrow.visible = false;

	};

	p.createStackObject = function()
	{	if(!this.selectedSprite){return;}
		var yAmount = this.checkEntity();
		app.sound.play("drop");
		var spriteYPos = this.selectedSprite.y + yAmount;
		var obj = new cm.StackObject(this.engine, this.selectedSprite.x, yAmount, this.stackContainer, this.selectedSprite.name, this.selectedSprite.size);
		this.engine.entities.push(obj);
		this.engine.bodies.push(obj.body);
		this.selectedObject = obj.body;
		obj.body.isSelected = true;
		this.stackContainer.removeChild(this.selectedSprite);
		this.selectedSprite.removeAllEventListeners();
		this.selectedSprite = null;
		this.stackingObjects.push(obj.displayObject);
		this.isWaitingForItem = true;
	};

	p.checkEntity = function()
	{
		var returnAmount = this.selectedSprite.y;
		for (var i = 0, l = this.engine.entities.length; i < l; i++) {
			var obj = this.engine.entities[i];
			var pos = obj.body.GetPosition();
			var objRegY = obj.displayObject.regY;
			var objRegX = obj.displayObject.regX;
			var xPos = pos.x * b2.b2Scale;
			var yPos = pos.y * b2.b2Scale;
			var spriteRegX = this.selectedSprite.regX + 10;
			var spriteRegY = this.selectedSprite.regY + 10;
			var spriteY = this.selectedSprite.y;
			var spriteX = this.selectedSprite.x;
			if(spriteX < xPos + objRegX && spriteX > xPos - objRegX && spriteY > yPos - objRegY && spriteY < yPos + objRegY){
				returnAmount = yPos - objRegY - 50;
			}
		}
		return returnAmount;
	};

	p.addPhysicsBox = function (name, num) {
		var obj = new cm.StackObject(this.engine, this.xPos, this.hookPool[num].y, this.stackContainer, name);
		this.engine.entities.push(obj);
		this.hangingPool.push(obj);
		this.engine.jointBodies(obj, this.hookPool[num]);
	};

	p.buildHooks = function()
	{
		// var hook = new cm.HookObject(this.engine, this.xPos, this.yPos, this.hookContainer, "hook");
		var hook = new cjs.Sprite(cm.Assets.lib.gameSS, "hook").set({x:this.xPos, y:this.yPos}).center();
		hook.regY += hook.regY-15;
		this.hookPool.push(hook);
		this.hookContainer.addChild(hook);
	};
	p.handleBGPressmove = function (e) {
		this.engine.mouseMove(e);
	};

	p.moveRuler = function()
	{
		this.canCheckMeasurement = true;
	};

	p.sendItemsUp = function()
	{
		if(this.hookPool[0].y > -299){
			this.isHiding = true;
			app.sound.play("servo-2");
		}
	};

	p.checkYposObjects = function ()
	{
		this.selectedObject = null;
		cjs.Tween.get(this).wait(2000).call(this.ySort, null, this);
	};

	p.ySort = function()
	{
		this.measureLine.isSensing = true;
		this.stackingObjects.sort(this.sortFunction);
		var pt = this.rulerContainer.localToLocal(100, 100, this);
		if(this.rulerContainer.y > 0)
		{
			if(this.stackingObjects[0].y < this.rulerContainer.y - this.rulerContainer.y){
				this.moveNewHeight();
			}
			else{
				this.isShowing = true;

				this.canCheckMeasurement = true;
			}
		}
		else{
			if(this.stackingObjects[0].y < this.rulerContainer.y){
				this.moveNewHeight();
			}
			else{
				this.isShowing = true;
				this.canCheckMeasurement = true;
			}
		}



	};

	p.sortFunction = function (obj1, obj2) {
        if (obj1.y > obj2.y) { return 1; }
        if (obj1.y < obj2.y) { return -1; }
        return 0;
    };

	p.getTopY = function()
	{

	};


	p.buildPhysicsScene = function () {
		///BORDER
		this.engine.createGround(0, (cm.app.display.height * 0.5) + 14, cm.app.display.width*10, 100);

		this.engine.createWall(-cm.app.display.width*5,0, 100, 4000);
		this.engine.createWall(cm.app.display.width*5,0, 100, 4000);

	};

	p.buildBodyFromData = function (data, world, bodyType, bool) {
		var fixtures = data.fixtures;
		var body;
		var bodyDef = new b2.b2BodyDef();
		bodyDef.type = bodyType;
		bodyDef.userData = this;
		if (bool)
			bodyDef.bullet = true;

		// create the body
		body = world.CreateBody(bodyDef);

		// prepare fixtures
		for (var i = 0; i < fixtures.length; i++) {
			var fixture = fixtures[i];
			var fixtureDef = new b2.b2FixtureDef();
			fixtureDef.density = fixture.density;
			fixtureDef.friction = fixture.friction;
			fixtureDef.restitution = fixture.restitution;
			fixtureDef.filter.categoryBits = fixture.categoryBits;
			fixtureDef.filter.maskBits = fixture.maskBits;
			fixtureDef.filter.groupIndex = fixture.groupIndex;
			fixtureDef.isSensor = fixture.isSensor;
			if (fixture.userData) fixtureDef.userData = fixture.userData;

			if (fixture.fixtureType === "POLYGON") {
				var polygons = fixture.polygons;
				for (var p = 0; p < polygons.length; p++) {
					var vertices = [];
					for (var m = 0; m < polygons[p].length; m++) {
						vertices.push(new b2.b2Vec2(polygons[p][m][0] / b2.b2Scale, polygons[p][m][1] / b2.b2Scale));
					}
					var polygonShape = new b2.b2PolygonShape();
					polygonShape.SetAsArray(vertices, vertices.length);
					fixtureDef.shape = polygonShape;
					body.CreateFixture(fixtureDef);
				}
			} else if (fixture.fixtureType === "CIRCLE") {
				var circleShape = new b2.b2CircleShape(fixture.radius / b2.b2Scale);
				circleShape.SetLocalPosition(new b2.b2Vec2(fixture.center[0] / b2.b2Scale, fixture.center[1] / b2.b2Scale));
				fixtureDef.shape = circleShape;
				body.CreateFixture(fixtureDef);
			}
		}

		return body;
	};

	p.start = function () {
		this.View_start();
		app.music = "mini-game";
		app.musicInstance.volume = cm.main.musicVolume;
		cjs.Tween.get(this.sharedUI).wait(2000).call(cm.app.sound.play, ["button-drop"], cm.app.sound).to({y: -9}, 250, cjs.Ease.quadOut);
		cjs.Tween.get(this).wait(2000).call(this.checkStartingScore, null, this);
	};

	p.animateIn = function () {
		return 0;
	};

	p.animateOut = function () {
		cm.ViewControl.transitIn();
		return 2000;
	};

	p.buttonHandler = function (e) {
		var sprite;
		if (e.type === "mouseover") {

			cjs.Tween.get(e.target).to({ scaleX: 1.1, scaleY: 1.1 }, 150);
		}

		if (e.type === "mouseout") {
			cjs.Tween.get(e.target).to({ scaleX: 1, scaleY: 1 }, 150);
		}

		if (e.type === "mousedown") {
			sprite = e.target.getChildAt(1);
			cjs.Tween.get(sprite).to({scaleX:0.9, scaleY:0.9}, 150);
		}

		if(e.type === "click") {
			cm.app.sound.play("click-1");
			sprite = e.target.getChildAt(1);
			this.handleClick(e.target.name);
			cjs.Tween.get(sprite).to({scaleX:1, scaleY:1}, 150, cjs.Ease.backOut);
		}
	};

	p.handleClick = function(name)
	{
		switch(name){
			case "pause-bg":

			break;
			case "help-bg":

			break;
			case "replay-btn":
				this.replayLevel();
			break;
			case "home-btn":
				this.goToView();
			break;
		}
	};

	p.goToView = function () {
		cm.main.pause = false;
		this.cleanUpBox2DBoxes();
		cjs.Tween.get(this).wait(100).call(cm.ViewControl.gotoView, ["SpaceView"], cm.ViewControl);
	};

	p.replayLevel = function()
	{
		cm.main.pause = false;
		this.cleanUpBox2DBoxes();
		cjs.Tween.get(this).wait(100).call(cm.ViewControl.gotoView, ["StackView"], cm.ViewControl);
		cm.ViewControl.transitIn();
	};

	p.moveNewHeight = function()
	{
		app.sound.play("camera-pan");
		cjs.Tween.get(this).set({moveUp: true}).wait(1500).set({moveUp:false}).call(this.setStackY, null, this);
		cjs.Tween.get(this).to({moveUpAmount:0.1}, 500, cjs.Ease.quadOut).wait(500).to({moveUpAmount:0}, 500, cjs.Ease.quadOut);
		this.isShowing = true;
	};

	p.setStackY = function()
	{
		this.stackY = this.rulerContainer.y - 284;
	};

	p.lerp = function(start, end, amt)
	{
		return (1-amt)*start+amt*end;
	};

	p.moveBodies = function ()
	{
		var i, l, body, pos;
		for ( i = 0, l = this.engine.bodies.length; i < l; i++) {
			body = this.engine.bodies[i];
			pos = body.GetPosition();

			pos.y = pos.y + this.moveUpAmount;
			body.SetPosition(pos);
		}

		for ( i = 0, l = this.engine.staticEntities.length; i < l; i++) {
			body = this.engine.staticEntities[i];
			pos = body.GetPosition();
			pos.y = pos.y + this.moveUpAmount;
			body.SetPosition(pos);
		}

		this.backgroundContainer.y = this.rulerContainer.y = this.rulerContainer.y + (this.moveUpAmount * b2.b2Scale);
		if(this.backgroundContainer.y > this.yParameter){
			this.addBackGround();
		}
	};

	p.addBackGround = function()
	{
		this.yParameter += 859;
		var yPos = 0;
		for (var i = 0, l = this.bgArray.length; i < l; i++) {
		   var b = this.bgArray[i];
		   yPos = b.y;
		}
		var background = new cjs.Bitmap(cm.Assets.lib.stackBackground).center();
		background.y = yPos-859;
		this.backgroundContainer.addChild(background);
		this.bgArray.push(background);
	};

	p.bringInItems = function()
	{
		if(this.gameEnded){return;}
		this.playClawDownSound();
		var hook;
		for (var i = 0, l = this.hookPool.length; i < l; i++) {
			hook = this.hookPool[i];
			var obj = this.hangingPool[i];
			cjs.Tween.get(hook).to({y:hook.y+700}, 2000, cjs.Ease.quadOut).call(this.afterItemsHandle, null, this);
			cjs.Tween.get(obj).to({y:obj.y+700}, 2000, cjs.Ease.quadOut).call(this.setupObjectEvents, [obj], this);

		}
	};

	p.setupObjectEvents = function(obj)
	{
		obj.on("mousedown", this.grabSound, this);
		obj.on("pressmove", this.handleHookObject, this);
		obj.on("pressup", this.createStackObject, this);
		this.keyNav.buttons.push(obj);
	};

	p.afterItemsHandle = function()
	{
		this.isShowing = false;
		this.canDestroy = true;
	};

	p.movingObjectHookHandle = function(e)
	{
		if(e.type === "pressup")
		{
			this.isShowing = true;
		}
	};

	p.handleStackObjectMouseDown = function()
	{
		this.isShowing = false;
		this.isHiding = true;
	};

	p.hideItems = function()
	{
		var hook;
		for (var i = 0, l = this.hookPool.length; i < l; i++) {
		    hook = this.hookPool[i];
			var obj = this.hangingPool[i];
			cjs.Tween.get(hook).to({y:hook.y-700}, 3000, cjs.Ease.quadIn);
			if(obj){
				cjs.Tween.get(obj).to({y:obj.y-700}, 3000, cjs.Ease.quadIn);
			}
		}
		cjs.Tween.get(this).wait(3000).call(this.destroyHangingItems, null, this);
	};

	p.spliceHangingObject = function(e)
	{
		if(this.selectedSprite){return;}
		this.removeHangingItemKeyNav();
		var objNum = this.hangingPool.indexOf(e.target);

		if(this.hangingPool[objNum] && this.hangingPool[objNum].mouseEnabled)
			this.hangingPool.splice(objNum, 1);

		for (var i = 0, l = this.hangingPool.length; i < l; i++) {
		   var item = this.hangingPool[i];
		   item.mouseEnabled = false;
		}


	};

	p.destroyHangingItems = function()
	{
		this.isHiding = false;
		if(this.hangingPool.length < 3)
		{
			for (var i = 0, l = this.hangingPool.length; i < l; i++) {
				var body = this.hangingPool[i];
				this.stackContainer.removeChild(body);
			}
			this.newItems();
		}

	};

	p.newItems = function()
	{
		if(this.gameEnded){return;}
		if(this.hangingPool.length < 3)
		{
			this.hangingPool = [];
			var i, l;
			for (i = 0, l = 3; i < l; i++) {
				var n = this.names[i];
				this.hookObject(n, i);
				this.xPos += 250;
				var move = this.names.splice(i,1);
				this.names.push(move[0]);
			}
			this.xPos = -200;
			this.showSelection();
		}
	};

	p.checkTopObjects = function()	{
		if(this.endGame){return;}
		var trigger1 = false;
			var trigger2 = false;
			var trigger3 = false;
			for (var i = 0, l = this.stackingObjects.length; i < l; i++) {
			   var object = this.stackingObjects[i];
			   if(i<3){
				if(object.y > 384){
					if(i===0)
						trigger1 = true;
					if(i===1)
						trigger2 = true;
					if(i===2)
						trigger3 = true;

					if(trigger1 && trigger2 && trigger3){
						this.endGame = true;
						app.sound.play("crash-game-over");
						this.engine.destroyGround();
						this.callEndGame();
					}
				}
				else {

					if(i===0)
						trigger1 = false;
					if(i===1)
						trigger2 = false;
					if(i===2)
						trigger3 = false;

				}
			   }

			}
	};

	p.handleKeyPress = function()
	{
		if (cm.main.pause) { return; }

		if(cm.Keyboard.state("upKey") || cm.Keyboard.state("downKey") || cm.Keyboard.state("leftKey") || cm.Keyboard.state("rightKey")){
			this.keysUsed = true;
		}

		if(cm.Keyboard.state("upKey")){
			if(this.selectedSprite)
				this.selectedSprite.y-=2;
		}

		if(cm.Keyboard.state("downKey")){
			if(this.selectedSprite)
				this.selectedSprite.y+=2;
		}
		if(cm.Keyboard.state("leftKey")){
			if(this.selectedSprite)
				this.selectedSprite.x-=2;
		}
		if(cm.Keyboard.state("rightKey")){
			if(this.selectedSprite)
				this.selectedSprite.x+=2;
		}
		if (cm.Keyboard.state("enterKey")) {
			if(this.selectedSprite)
				this.createStackObject();
		}
	};

	p.resize = function()
	{
		this.sharedUI.resize();
	};

	p.update = function () {
		if (this.engine && this.canUpdate && !cm.main.pause) {
			this.engine.update();
			if(this.moveUp)
				this.moveBodies();

			if(this.selectedObject){
				if(!this.selectedObject.IsAwake() && !this.isHiding || this.measureTimer > 100){
					this.checkYposObjects();
					this.measureTimer = 0;
				}
				else {
					this.isShowing = false;
					this.measureLine.stopSensing();
					this.measureTimer++;
				}
			}
			this.checkTopObjects();
		}
		if(!cm.Device.mobile)
			this.handleKeyPress();
		if(cm.Keyboard){
			this.keyNav.keyCheck();
			cm.Keyboard.clearPressed();
		}
	};

	p.cleanUpBox2DBoxes = function()
	{

		this.measureLine.sensor.kill();
		var body, i, l;
		for ( i = 0, l = this.hangingPool.length; i < l; i++) {
			body = this.hangingPool[i];
			this.removeHangingItemKeyNav();
			this.stackContainer.removeChild(body);
		}

		this.engine.removeAllEntities();
		this.engine.kill();

	};

	p.setActive = function(bool) {
		if (!bool) {
			this.keyNav.removeEventsOnButtons();
		}
	};

	p.destroy = function () {
		this.View_destroy();
	};

	cm.View.StackView = cjs.promote(StackView, "View");
})();